import $ from 'jquery';
import resizeVideos from './resizeVideos';
import autoPauseResume from './autoPauseResume';
import themeEditor from './themeEditor';
import { native_players, nativePlayerInit } from './nativePlayer';
import { youtube_players, youtubePlayerInit } from './youtubePlayer';
import { vimeo_players, vimeoPlayerInit } from './vimeoPlayer';

const BackgroundVideo = () => {
  // NATIVE MP4
  $('[data-background-video][data-video-type="native"]').each((i, container) => {
    nativePlayerInit(container);
  });

  // VIMEO
  $('[data-background-video][data-video-type="vimeo"]').each((i, container) => {
    vimeoPlayerInit(container);
  });

  $(window).on('scroll', () => {
    autoPauseResume(native_players, 'native');
    autoPauseResume(vimeo_players, 'vimeo');
  });

  $(document).on('heroCarouselDidChange', () => {
    autoPauseResume(native_players, 'native');
    autoPauseResume(vimeo_players, 'vimeo');
  });

  // ALL VIDEOS

  $(window).on('resize', () => {
    resizeVideos();
  });

  themeEditor();

  // YOUTUBE
  // This should have been clean and just like the above, but we have to do this dirty shit with window.onYouTubePlayerAPIReady
  // since there isn't a nice ES6 way of properly using the youtube iframe API.  All the npm modules out there suck.
  let api_ready_fired = false;

  window.onYouTubePlayerAPIReady = () => {
    api_ready_fired = true;

    $('[data-background-video][data-video-type="youtube"]').each((i, container) => {
      youtubePlayerInit(container);
    });

    $(window).on('scroll', () => {
      autoPauseResume(youtube_players, 'youtube');
    });

    $(document).on('heroCarouselDidChange', () => {
      autoPauseResume(youtube_players, 'youtube');
    });
  };

  // YouTube fires this automatically when it loads, but if youtube loads before us, we'll fire it
  if (window.YT && window.YT.Player && !api_ready_fired) {
    window.onYouTubePlayerAPIReady();
  }
};

export { BackgroundVideo };